import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { Box } from '@bridebook/ui';
import { applyFormatter } from '@bridebook/web/app-shared/lib/supplier/formatters';
import { getIsNewSupplier } from '@bridebook/web/app-shared/lib/supplier/utils/get-is-new-supplier';
import { IconClass } from '@bridebook/web/lib/ui/constants';
import componentStyle from '@bridebook/web/app-basic/components/supplier/sections/profile-highlights/profile-highlights.style';

interface ProfileHighlightsProps {
  currency: string;
  market: Market;
  priceFrom: number;
  weddingsServedRange: [number] | [number, number];
}

const ProfileHighlights = ({
  currency,
  market,
  priceFrom,
  weddingsServedRange,
}: ProfileHighlightsProps) => {
  const { t } = useTranslation('supplier');
  const isNewSupplier = getIsNewSupplier(weddingsServedRange);
  const highlights = [
    {
      value: market.formatCurrency(priceFrom, {
        currency,
        maximumFractionDigits: 0,
      }),
      icon: IconClass.Budget,
      label: t('section.highlights.priceFrom'),
    },
    {
      value: isNewSupplier
        ? t('section.highlights.new')
        : applyFormatter('company.weddingsHostedShort', weddingsServedRange),
      icon: IconClass.Photographer,
      label: isNewSupplier
        ? t('section.highlights.supplier')
        : t('section.highlights.weddingsShoot'),
    },
  ];
  const styles = componentStyle();

  return (
    <Box as="ul" style={styles.wrapper}>
      {highlights.map(({ value, icon, label }, index) => (
        <Box as="li" style={styles.item} key={index}>
          <Box as="span" className={icon} style={styles.icon} />
          <Box as="span" style={styles.value}>
            {value}
          </Box>
          <Box as="span" style={styles.label}>
            {label}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default memo(ProfileHighlights);
